import {
  LOGIN_SUCCESS, 
  LOGIN_ERROR,
  GET_IS_AUTH_SUCCESS, 
  GET_IS_AUTH_ERROR,
  LOGOUT_SUCCESS, 
  SET_LOADING,

  MFA_REQUIRED,
  MFA_VERIFY_ERROR,
  MFA_CLEAR,
} from '../types/actionTypes';

const INIT_STATE = {
  auth: {
    authenticated: false,
    canLogin: false,
  },
  mfa: {
    required: false,
    type: null,       // 'TOTP' | 'EMAIL'
    token: null,      // mfaToken (ticket)
    emailMasked: null,
    canLogin: false,  // guardo el hint para redirección final
  },
  user: '',
  error: '',
  loading: false,
};

export default (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        auth: payload,
        mfa: { ...INIT_STATE.mfa }, // limpio MFA
        error: '',
      };
    case LOGIN_ERROR:
      return {
        ...state,
        auth: {
          authenticated: false,
          canLogin: false,
        },
        mfa: { ...INIT_STATE.mfa },
        error: payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        auth: {
          authenticated: false,
          canLogin: false,
        },
        mfa: { ...INIT_STATE.mfa },
        error: '',
      };
    case GET_IS_AUTH_SUCCESS:
      return {
        ...state,
        auth: {
          ...state.auth,
          authenticated: payload.authenticated,
        },
        error: '',
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case GET_IS_AUTH_ERROR:
      return {
        ...state,
        auth: {
          authenticated: false,
          canLogin: false,
        },
        error: '',
      };
    // MFA cases ========================================================================
    case MFA_REQUIRED:
      return {
        ...state,
        auth: { authenticated: false, canLogin: false }, // aún NO autenticado
        mfa: {
          required: true,
          type: payload?.mfaType || payload?.type || 'TOTP',
          token: payload?.mfaToken || payload?.token || null,
          emailMasked: payload?.emailMasked || null,
          canLogin: !!payload?.canLogin,
        },
        error: '',
      };
    case MFA_CLEAR:
      return {
        ...state,
        mfa: { ...INIT_STATE.mfa },
        error: '',
      };
    case MFA_VERIFY_ERROR:
      return {
        ...state,
        error: payload,
      };
        default:
          return { ...state };
      }
      // End MFA cases ===================================================================
};
